// Represents an identifier for a data source node
const nodeId = (id, ds) => ({ id, ds });


export default nodeId;